import { QueryClient } from '@tanstack/react-query';

// React Query 클라이언트 설정
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 기본 설정
      staleTime: 5 * 60 * 1000, // 5분
      gcTime: 10 * 60 * 1000, // 10분 (이전 cacheTime)
      retry: 3,
      retryDelay: 1000,
      refetchOnWindowFocus: false, // 탭 활성화 시 자동 새로고침 비활성화
      refetchOnReconnect: true, // 네트워크 재연결 시 새로고침
      
      // 전역 에러 처리
      onError: (error) => {
        console.error('Query Error:', error);
        // 여기에 전역 에러 처리 로직 추가 (예: toast 알림)
      },
    },
    mutations: {
      // 뮤테이션 기본 설정
      retry: 1,
      retryDelay: 1000,
      
      onError: (error) => {
        console.error('Mutation Error:', error);
        // 여기에 전역 에러 처리 로직 추가
      },
    },
  },
});

export default queryClient;
